// API base URL selection.
// Switch backends with REACT_APP_API_TARGET = local | test | production (defined in .env).
//   `npm start`      -> uses REACT_APP_API_TARGET from .env
//   `npm run build`  -> pinned to production via .env.production (ignores the dev setting)
// Remember: env vars are read once at startup — restart the dev server after changing .env.

import { choiseHttpOrHttps } from "./handleTheHttp(s)ForPhones";

const TARGET = (process.env.REACT_APP_API_TARGET || "production")
  .trim()
  .toLowerCase();

const URL_BY_TARGET = {
  local: process.env.REACT_APP_API_LOCAL_URL,
  test: process.env.REACT_APP_API_TEST_URL,
  production: process.env.REACT_APP_API_PRO_URL,
};

const raw = (
  URL_BY_TARGET[TARGET] ||
  process.env.REACT_APP_API_PRO_URL ||
  ""
).trim();

// If the configured value already includes a protocol (e.g. http://127.0.0.1:8000/api/V1),
// use it verbatim; otherwise prepend the device-appropriate protocol (https:// on desktop).
const apiUrl = /^https?:\/\//i.test(raw) ? raw : choiseHttpOrHttps() + raw;

export default apiUrl;
